import cn from 'classnames'
import { observer } from 'mobx-react'
import React, { useEffect } from 'react'

import { SCROLL_DISPLAY_TIME } from '../../constants/NavItemConstants'
import ApplicationNavItemsController from '../../controllers/ApplicationNavItemsController/ApplicationNavItemsController'
import TemplatesSectionNavItemController from '../../controllers/TemplatesSectionNavItemController/TemplatesSectionNavItemController'

import { containerClassName } from './styles'

import './index.css'

const HomeNavbarBody = (): React.ReactElement => {
   const handleScroll = (): void => {
      const element = document.getElementById('navbarBody')
      if (!element) return

      if (element.classList.contains('navbar-on-scrollbar') === false) {
         element.classList.add('navbar-on-scrollbar')
      }

      // eslint-disable-next-line prefer-const
      let timer
      clearTimeout(timer)

      timer = setTimeout(() => {
         if (element.classList.contains('navbar-on-scrollbar')) {
            element.classList.remove('navbar-on-scrollbar')
         }
      }, SCROLL_DISPLAY_TIME)
   }
   useEffect(() => {
      const element = document.getElementById('navbarBody')
      if (!element) return

      element.addEventListener('scroll', handleScroll, true)

      return () => {
         element.removeEventListener('scroll', handleScroll, true)
      }
   }, [])

   return (
      <div
         className={cn(containerClassName, 'navbar-body-container')}
         id='navbarBody'
      >
         <TemplatesSectionNavItemController />
         <ApplicationNavItemsController />
      </div>
   )
}

export default observer(HomeNavbarBody)
